module.exports = __webpack_public_path__ + "img/c_2.3cf61abd.png";